import styled from "styled-components";

export const CustomerReviewWrap = styled.div`
    padding-bottom: 30px;
`;

export const SummaryCardsContainer = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 32px;
    flex-wrap: wrap;
`;

export const SummaryCard = styled.div`
    flex: 1;
    min-width: 220px;
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);

    .icon-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.food {
            background-color: #ffebe3;
        }
        &.driver {
            background: #FFF8E;
        }
        &.total {
            background: #ffebe3;
        }
        &.complaints {
            background: #ffe5e5;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .label {
            font-size: 15px;
            color: #666;
        }

        .value {
            font-size: 32px;
            font-weight: 700;
            color: #1f2937;
            display: flex;
            align-items: baseline;
            gap: 6px;

            span {
                font-size: 16px;
                font-weight: 500;
                color: #9ca3af;
            }
        }
    }
`;

export const HighlightCardsContainer = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 40px;
    flex-wrap: wrap;
`;

export const HighlightCard = styled.div`
    flex: 1;
    min-width: 280px;
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);

    .icon-wrapper {
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: #D92D20;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 6px;

        .label {
            font-size: 15px;
            color: #6b7280;
        }

        .value {
            font-size: 24px;
            font-weight: 600;
            color: #1f2937;
        }

        .sub-value {
            font-size: 15px;
            color: #6b7280;
            display: flex;
            align-items: center;
            gap: 6px;

            svg {
                color: #D92D20;
            }
        }
    }
`;

export const ReviewWrap = styled.div`
    .title {
        margin-bottom: 24px;
        h2 {
            font-size: 24px;
            font-weight: 600;
            color: #1f2937;
            display: flex;
            align-items: center;
            gap: 8px;

            span {
                color: #9ca3af;
                font-weight: 400;
                font-size: 20px;
            }
        }
    }
`;

export const ReviewsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 24px;
`;

export const ReviewCard = styled.div`
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .card-inner {
        padding: 24px;
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .item-tag {
            background: #fff0e8;
            color: #D92D20;
            padding: 6px 14px;
            border-radius: 30px;
            font-size: 13px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .rating {
            display: flex;
            align-items: center;
            gap: 6px;
            font-weight: 600;
            font-size: 16px;
            color: #1f2937;

            .stars {
                display: flex;
                gap: 4px;
                color: #D92D20;
                margin-right: 4px;
            }
        }
    }

    .comment {
        font-size: 15px;
        color: #4b5563;
        line-height: 1.6;
        flex: 1;
        margin-bottom: 24px;
    }

    .user-info {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 20px;

        .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: #f3f4f6;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #6b7280;
            font-size: 16px;
            font-weight: 500;
        }

        .details {
            font-size: 15px;
            color: #1f2937;
            font-weight: 600;

            span {
                color: #9ca3af;
                font-weight: 400;
            }
        }
    }

    .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 24px;

        .tag {
            padding: 6px 14px;
            border-radius: 30px;
            font-size: 13px;
            font-weight: 500;

            &.positive {
                background: #e8f5e9;
                color: #4caf50;
            }
            &.negative {
                background: #ffebee;
                color: #f44336;
            }
            &.neutral {
                background: #f3f4f6;
                color: #6b7280;
            }
        }
    }

    .footer {
        padding-top: 20px;
        border-top: 1px solid #f0f0f0;

        button {
            background: #D92D20;
            color: #fff;
            border: none;
            border-radius: 30px;
            padding: 10px 32px;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: opacity 0.2s;

            &:hover {
                opacity: 0.9;
            }
        }
    }
`;
